import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import { Link as RouterLink } from 'react-router-dom';
import SearchField from './SearchField';

function PageHeader({
  title,
  searchValue,
  onSearchChange,
  searchPlaceholder = 'Pesquisar',
  actionLabel,
  actionIcon,
  actionTo,
  onActionClick,
  children,
}) {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: { xs: 'column', sm: 'row' },
        alignItems: { xs: 'stretch', sm: 'center' },
        justifyContent: 'space-between',
        gap: 2,
        mb: 3,
      }}
    >
      <Typography variant="h5" component="h1" sx={{ color: 'primary.main', fontWeight: 600 }}>
        {title}
      </Typography>

      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: 2,
          flexWrap: 'wrap',
          width: { xs: '100%', sm: 'auto' },
        }}
      >
        {onSearchChange && (
          <SearchField
            value={searchValue}
            onChange={onSearchChange}
            placeholder={searchPlaceholder}
            sx={{ width: { xs: '100%', sm: 'auto' }, minWidth: { xs: 0, sm: 220 } }}
          />
        )}
        {children}
        {actionLabel &&
          (actionTo ? (
            <Button
              variant="contained"
              color="secondary"
              startIcon={actionIcon}
              component={RouterLink}
              to={actionTo}
              sx={{ width: { xs: '100%', sm: 'auto' } }}
            >
              {actionLabel}
            </Button>
          ) : (
            <Button
              variant="contained"
              color="secondary"
              startIcon={actionIcon}
              onClick={onActionClick}
              sx={{ width: { xs: '100%', sm: 'auto' } }}
            >
              {actionLabel}
            </Button>
          ))}
      </Box>
    </Box>
  );
}

export default PageHeader;
